/**
 * Unique id per browser tab so the same account in two sessions
 * can collaborate with itself (live typing, editing indicators).
 */
export function getCollaborationSessionId() {
  const key = 'jbx-collab-session';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(key, id);
  }
  return id;
}
